type Props = Readonly<{
  label: string;
}>;

export default function SearchSuggestionLabel({ label }: Props): JSX.Element {
  return (
    <div className='d-flex'>
      <i
        aria-hidden
        className='icon-search me-1'
        style={{ fontFamily: 'lupo', fontSize: '1.3rem' }}
      />
      <span>{label}</span>
    </div>
  );
}
